module.exports = __webpack_public_path__ + "static/media/RRD3-BG2.147522ee.jpg";